export default {
  RESELLER: 'agent',
  SUPPLIER: 'hotelier',
  ADMIN: 'admin',
};
